import React, { useState } from 'react'
import { ChevronUp, ChevronDown } from 'react-bootstrap-icons'

export default function ShowMoreBtn({ showMore, handleClick }) {

  return (
    <button
      className='flex items-center justify-between gap-1 dark:text-white'
      onClick={() => {
        handleClick()
      }}
    >
      <span className='font-bold text-sm'>Show {showMore ? 'less' : 'more'}</span>
      {showMore ? <ChevronUp /> : <ChevronDown />}
    </button>
  )
}
